export default "__VITE_ASSET__M77QP_Zy__"